import request from '../utils/request';
import { getLanguageUrl } from "@/utils/index";

/**
 * 课程列表
 */
export function learningtourNew(params) {
    
    let url = ''

    if (process.env.ENV_CONFIG =='devOverseas' || process.env.ENV_CONFIG =='prodOverseas' || process.env.ENV_CONFIG == 'thdev' || process.env.ENV_CONFIG == 'thuat' || process.env.ENV_CONFIG == 'thprod'){
        url = '/sr/learningtour'
    }else{
        url = '/sr/v2/learningtournew'
    }
    url = getLanguageUrl(url)
    return request.MainService({
        url: url,
        method: 'get',
        data: params
    })
}
/**
 * 获取用户课程进度
 */
export function learningProgress(params) {
    return request.MainService({
        url: '/ddilearner/v2/user/learning/progress',
        method: 'get',
        data: params
    })
}
/**
 * 获取是否展示学习弹窗
 * @param {*} id 
 * learningPathMetaId 课程配置ID 需加上0009
 */
export function getOnceino(id) {
    return request.MainService({
        url: `/sr/onceino/${id}`,
        method: 'get',
        data: {}
    })
}
/**
 * 保存点击学习收获弹窗
 * @param {*} id 
 * learningPathMetaId 课程配置ID 需加上0009
 */
export function postOnceino(id) {
    return request.MainService({
        url: `/sr/onceino/${id}`,
        method: 'post',
        data: {}
    })
}
/**
 * 获取单门课程进度
 * @param {*} id 
 * learningPathMetaIds 课程配置ID
 */
export function learnProgress(id) {
    return request.MainService({
        url: `/ddilearner/v2/user/learning/progress?learningPathMetaIds=${id}`,
        method: 'get',
        data: {}
    })
}
//获取当前课程测学练考内容
export function learningpathesUser(params, data) {
    return request.MainService({
        url: `/ddilearner/v2/user/learningpathes/${data.id}`,
        method: 'get',
        params: params
    })
}
//获取当前课程测学练考内容
export function learningpathes(params, data) {
    return request.MainService({
        url: `/ddilearner/v2/learningpathes/${data.id}`,
        method: 'get',
        params: params
    })
    // response data
    // type为模块类型 1-课前诊断 2-课程学习 3-情景模拟 4-课后考核 null-已完成
    // 当type=1 或 type=4 id为null
    // 当type=2 当前id为微课练习id
    // 当type=3 当前id为情景模拟练习id
}

/**
 * 保存用户填写反馈问卷信息
 */
export function saveUsersSatisficing(params) {
    return request.MainService({
        url: '/ddilearner/v1/usersSatisficing',
        method: 'post',
        data: params
    });
}

/**
 * 获取用户填写反馈问卷信息
 * @param id 
 * @returns 
 */
export function getUsersSatisficingMetasInfo(id) {
    return request.MainService({
        url: `/ddilearner/v1/usersSatisficing/learningPathMetaId/${id}`,
        method: 'get',
        data: {}
    })
}

/**
 * 获取反馈问卷信息（当用户完成情景模拟以及未填写反馈问卷）
 * @returns 
 */
export function getUsersSatisficingMetas() {
    return request.MainService({
        url: `/ddilearner/v1/usersSatisficingMetas`,
        method: 'get',
        data: {}
    })
}

/**
 * 每一次测验记录时长初始化 
 * 说明：当DNA测验每一次打开需要计时器的情况下调用本次接口
 * @type 0 DNA 2前测 3后测
 */
export function tickInit(params) {
    return request.MainService({
        url: `/ddilearner/v1/user/tick/init/${params.type}`,
        method: 'post',
        data: params
    });
}

/**
 * 发送计时接口（每隔1秒调用一次）
 * 说明：用于记录每个测验所花费的时长
 */
export function tickUpdate(params) {
    return request.MainService({
        url: `/ddilearner/v1/user/tick/update/${params.tickId}`,
        method: 'post',
        data: params
    });
}

/**
 * 每一次测验记录时长重置
 */
 export function tickReset(params) {
    return request.MainService({
        url: `ddilearner/v1/user/tick/reset/${params.type}`,
        method: 'post',
        data: params
    });
}





// WEBPACK FOOTER //
// ./src/api/course.js